module.exports = __webpack_public_path__ + "img/imgzhuy-wxz.06216ffd.png";